import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconEyeClosed = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "silver",
		d: "M10 5.833c2.3 0 4.167 1.867 4.167 4.167 0 .542-.108 1.05-.3 1.525l2.434 2.433c1.258-1.05 2.25-2.408 2.858-3.958-1.442-3.658-5-6.25-9.167-6.25-1.166 0-2.283.208-3.316.583l1.8 1.8c.475-.191.983-.3 1.525-.3zM1.668 3.558l1.9 1.9.384.384C2.567 6.917 1.484 8.35.834 10c1.442 3.658 5 6.25 9.167 6.25 1.291 0 2.525-.25 3.65-.7l.35.35 2.441 2.433 1.059-1.058L2.726 2.5 1.667 3.558zm4.609 4.609l1.291 1.291c-.041.175-.066.359-.066.542 0 1.383 1.116 2.5 2.5 2.5.183 0 .366-.025.541-.067l1.292 1.292c-.558.275-1.175.442-1.833.442-2.3 0-4.167-1.867-4.167-4.167 0-.658.167-1.275.442-1.833zm3.591-.65l2.625 2.625.017-.134c0-1.383-1.117-2.5-2.5-2.5l-.142.009z"
	})
});
export default SvgIconEyeClosed;
